var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 382.07,
    height: 232.291,
    viewBox: "0 0 382.07 232.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8962",
    "data-name": "Group 8962",
    transform: "translate(44.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27110",
    "data-name": "Path 27110",
    d: "M172.558,271.161s-70.749,39.695-92.692,45.663c-8.687,2.362-124.338,53.954-124.338,53.954l92.306,32.485,97.218-86.519Z",
    transform: "translate(0 -170.971)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27111",
    "data-name": "Path 27111",
    d: "M121.823,416.126l.7.289L106.467,428.8l8.5,9.322L212.181,351.6l4.992-8.272-15.282-16.884q-2.592,1.355-5.236,2.721l-8.49,37.671-42.506,32.1Z",
    transform: "translate(-67.129 -205.826)",
    fill: "#ac5a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27112",
    "data-name": "Path 27112",
    d: "M326.922,164.215c1.2-2.733,8.269-33.487,7.12-34.492-3.858-3.372-11.024-.461-11.929-1.353-.565-.558.576-2.677,1.5-3.611a132.345,132.345,0,0,1,10.454-8.232c1.135-.536,12.068,2.691,15.872.868,0,0,21.865-10.731,23.588-12.376S510.016,0,510.016,0L540.6,72.13,372.9,137.351s-9.092,14.5-11.128,15.132a20.989,20.989,0,0,1-5.625.433s-2.361,5-3.7,4.857a35.917,35.917,0,0,1-5.13-1.578s-3.236,3.969-4.241,3.722a26.413,26.413,0,0,1-3.995-2.113s-4.77,7.831-6.53,8.7c-4.363,2.144-7.267,1.481-5.619-2.285",
    transform: "translate(-203.002)",
    fill: "#ff9780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27113",
    "data-name": "Path 27113",
    d: "M541.16,206.894c-7.878,3.219-19.947,8.624-19.947,8.624-18.1,7.893-31.109,13.77-31.592,14.262-1.741,1.769-18.679,13.616-19.954,14.507l164.063-64.126-3.741-8.824c-15.509,4.714-55.484,21.262-88.828,35.557",
    transform: "translate(-296.131 -108.03)",
    fill: "#ff806e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27114",
    "data-name": "Path 27114",
    d: "M333.523,330.2c-1.547-1.327-7.931,2.6-11.38,4.93-.2.556-.258,1.041-.028,1.267.9.892,8.071-2.019,11.929,1.353a.527.527,0,0,1,.106.313c.423-2.879.681-6.741-.627-7.862",
    transform: "translate(-203.004 -208.028)",
    fill: "#ff806e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27115",
    "data-name": "Path 27115",
    d: "M415.951,402.914a17.253,17.253,0,0,0-1.343,3.482,24.267,24.267,0,0,0,4.726-.232c-.638-1.78-1.353-3.761-1.47-4.031-.217-.5-1.651.814-1.912.782",
    transform: "translate(-261.416 -253.477)",
    fill: "#ff806e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27116",
    "data-name": "Path 27116",
    d: "M368.8,414.127c-.675.175-3.3,5.721-3.3,5.721s.1.107.265.28c.466-.734.758-1.213.758-1.213a26.4,26.4,0,0,0,3.995,2.113c.311.077.838-.252,1.415-.742-1.035-2.5-2.678-6.276-3.131-6.159",
    transform: "translate(-230.453 -261.112)",
    fill: "#ff806e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27117",
    "data-name": "Path 27117",
    d: "M335.852,378.941s8.275-33.725,7.58-38.68",
    transform: "translate(-211.76 -214.54)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3595",
    "data-name": "Line 3595",
    y1: 8.736,
    x2: 4.443,
    transform: "translate(134.068 152.199)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27118",
    "data-name": "Path 27118",
    d: "M390.557,410.335s3.356,2.162,5.809,1.229,4.421-7.987,4.421-7.987l1.353-.509",
    transform: "translate(-246.252 -254.14)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27119",
    "data-name": "Path 27119",
    d: "M380.846,409.668c-.162.083-2.171.75-2.732,1.752s-4.236,6.911-5.741,7.066-4.1-2.381-4.1-2.381",
    transform: "translate(-232.198 -258.302)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27120",
    "data-name": "Path 27120",
    d: "M411.881,274.531s6.573-14.923,7.527-15.359,13.3-6.722,14.591-6,7.489,6.938,9.326,8.875c1.69,1.783-.738,4.068-4.922,5.776-1.437.587-8.321-3.256-8.321-3.256a36.806,36.806,0,0,1-6.735,3.965c-1.195.45-11.466,6-11.466,6",
    transform: "translate(-259.697 -159.591)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27121",
    "data-name": "Path 27121",
    d: "M429.155,262.653s8.705,6.064,11.151,5.265,5.882-2.587,4.921-5.776c0,0-8.005-8.8-9.326-8.876s-13.112,4.8-14.59,6-6.412,12.2-6.412,12.2",
    transform: "translate(-261.6 -159.687)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27122",
    "data-name": "Path 27122",
    d: "M429.832,301.2s-1.89-5.889-.851-6.363,10.7-5.015,11.64-4.268,2.949,5.126,2.839,5.237a16.186,16.186,0,0,1-2.128.306s-2.079-4.622-2.345-4.487-7.9,3.083-8.338,3.642,1.212,4.34,1.212,4.34Z",
    transform: "translate(-270.282 -183.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27123",
    "data-name": "Path 27123",
    d: "M459.1,338.939s1.891,5.888.852,6.363-10.7,5.016-11.639,4.269-2.95-5.125-2.84-5.237a16.189,16.189,0,0,1,2.129-.306s2.08,4.622,2.346,4.487,7.9-3.085,8.337-3.643-1.212-4.34-1.212-4.34Z",
    transform: "translate(-280.873 -213.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27124",
    "data-name": "Path 27124",
    d: "M429.789,292s-1.865-3.036-.436-3.765,9.042-5.224,10.133-3.528a4.607,4.607,0,0,1,.677,3.352Z",
    transform: "translate(-270.374 -179.269)",
    fill: "#343c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27125",
    "data-name": "Path 27125",
    d: "M457.541,358.451s-3.084-3.572-2.195-4.476,8.752-4.916,9.39-3.665a37.2,37.2,0,0,1,1.564,4.832Z",
    transform: "translate(-287.001 -220.724)",
    fill: "#343c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27126",
    "data-name": "Path 27126",
    d: "M426.8,322.157s-2.02-.579-2.115-.99.214-1.834.67-2.067,2.065.556,2.065.556Z",
    transform: "translate(-267.757 -201.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27127",
    "data-name": "Path 27127",
    d: "M439.538,348.253s-.617,2.009-1.03,2.1-1.829-.248-2.054-.709.595-2.055.595-2.055Z",
    transform: "translate(-275.167 -219.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27128",
    "data-name": "Path 27128",
    d: "M429.136,335.888s-1.936.817-2.268.556-.984-1.562-.775-2.029,1.957-.863,1.957-.863Z",
    transform: "translate(-268.632 -210.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27129",
    "data-name": "Path 27129",
    d: "M435.434,301.334c10.855-4.546,21.058,10.908,8.029,17.994-12.457,6.775-20.624-12.719-8.029-17.994",
    transform: "translate(-270.575 -189.477)",
    fill: "#343c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27130",
    "data-name": "Path 27130",
    d: "M440.568,307.087c8.1-3.37,15.873,8.487,6.17,13.774-9.277,5.055-15.563-9.863-6.17-13.774",
    transform: "translate(-274.856 -193.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27131",
    "data-name": "Path 27131",
    d: "M473.715,316.953c-2.425.305-3.32,4.121-2.937,5,.291.668,8.148,5.01,12.628,7.218l-1.306.764c.963.886,4.291.908,4.356.458,1.4.469,4.038-1.344,4.811-2.29a35.383,35.383,0,0,0,2.277-3.819c-.76-2.121-17.4-7.634-19.829-7.329",
    transform: "translate(-296.779 -199.836)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27132",
    "data-name": "Path 27132",
    d: "M514.631,341.162s-1.973,4.392-6.421,4.555l-2.7.167",
    transform: "translate(-318.734 -215.108)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27133",
    "data-name": "Path 27133",
    d: "M470.921,321.96s-.143-5.229,2.937-5c7.4.553,17.007,6.522,17.159,6.98",
    transform: "translate(-296.922 -199.844)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27134",
    "data-name": "Path 27134",
    d: "M475.859,336.486s-11.5-7.963-13.2-6.76c-1.876,1.33-1.812,2.33-1.652,3.533s9.212,6.343,8.986,6.677-5.25,1.84-5.9,2.618-4.14,1.2-3.472,1.653,5.238,2.182,7.03,1.69,6.389-3.516,7.247-4.218c5.041-4.124,1.32-5.191.956-5.193",
    transform: "translate(-290.378 -207.819)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27135",
    "data-name": "Path 27135",
    d: "M495.309,353.379s4.228-3.062,3.771-4.131-3.416-2.749-3.416-2.749",
    transform: "translate(-312.3 -218.473)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27136",
    "data-name": "Path 27136",
    d: "M485.541,358a4.165,4.165,0,0,0-.94,3.34",
    transform: "translate(-305.514 -225.723)",
    fill: "none",
    stroke: "#25293d",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27137",
    "data-name": "Path 27137",
    d: "M472.447,340.854s-10.4-5.73-10.76-7.44.656-3.642,2.473-3.563,8.511,4.534,8.511,4.534",
    transform: "translate(-291.055 -207.974)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27138",
    "data-name": "Path 27138",
    d: "M522.437,316.237s1.073,1.844.552,2.963-1.795,3.691-2.725,3.791-6.993-1.107-8.117-1.262-9.709-4.323-9.355-5.557,2.969-5.224,4.767-4.974,7.058,2.627,7.058,2.627,5.786.893,7.82,2.412",
    transform: "translate(-317.012 -196.208)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27139",
    "data-name": "Path 27139",
    d: "M523.529,318.724s-.38,3.656-2.333,4.286c-2.608.842-15.108-3.765-16.387-5.477s-.432-5.474,3.682-6.317c0,0,9.948,3.239,13.85,4.864",
    transform: "translate(-317.943 -196.227)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27140",
    "data-name": "Path 27140",
    d: "M560.925,311.956s-4.558-4.066-6.571-3.337c-1.982.718-4.859,2.91-5.217,3.92s1.213,3.36,1.213,3.36,3.294,2.919,5.97,2.032a6.8,6.8,0,0,0,4.6-5.975",
    transform: "translate(-346.206 -194.534)",
    fill: "#b8756e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27141",
    "data-name": "Path 27141",
    d: "M551.64,316.339s-3.321-1.738-2.591-3.6,4.7-4.366,6.316-3.814,4.45,1.864,5.116,3.127",
    transform: "translate(-346.117 -194.732)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3596",
    "data-name": "Line 3596",
    y1: 4.504,
    x2: 10.66,
    transform: "translate(169.654 132.087)",
    fill: "none",
    stroke: "#25293d",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmsIcon);
export default __webpack_public_path__ + "static/media/ArmsIcon.90841300828147beb2596b535aaa39aa.svg";
export { ForwardRef as ReactComponent };